import {
  Space,
  Input,
  Button,
  Card,
  Row,
  Col,
  Form,
  Typography,
  Descriptions,
  Table,
  Divider,
} from 'antd';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { SearchOutlined } from '@ant-design/icons';
import ShareHoldingService from '../../services/ShareHoldingService';
import { useAuth } from '../../hooks/useAuth';
import { useForm } from 'antd/es/form/Form';
import { useNavigate, useParams } from 'react-router-dom';

// style components with mediaQuery for different screen sizes
const SpaceWrapper = styled(Space)`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: flex-start;
  margin: 1rem 0;
  @media (min-width: 500px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin: 0 0 2rem 0;
  }
`;

const { Text, Title } = Typography;

const ShareHolding = () => {
  const [tradingAccountDetail, setTradingAccountDetail] = useState();
  const { showNotification } = useAuth();
  const [form] = useForm();
  const navigate = useNavigate();
  const { tradingAccountNo } = useParams();
  const [loading, setLoading] = useState(false);

  const renderData = () => {
    form.setFieldsValue({
      tradingAccountNo: tradingAccountNo,
    });
  };

  const fetchData = async () => {
    if (!tradingAccountNo) {
      return; // Skip API call if tradingAccountNo is not available
    }
    setLoading(true);
    const result = await ShareHoldingService.getTradingAccountDetail({ tradingAccountNo });
    setLoading(false);
    console.log(result);

    if (result.success) {
      // showNotification('success', 'Successfully submitted');
      setTradingAccountDetail(result.data);
    } else {
      showNotification('error', result.message);
    }
  };

  const handleSearch = async formValues => {
    const payload = {
      tradingAccountNo: formValues.tradingAccountNo,
    };
    setLoading(true);
    const result = await ShareHoldingService.getTradingAccountDetail(payload);
    setLoading(false);
    console.log(result);

    if (result.success) {
      // showNotification('success', 'Successfully submitted');
      setTradingAccountDetail(result.data);
    } else {
      showNotification('error', result.message);
    }
  };

  useEffect(() => {
    renderData();
    fetchData();
  }, []);

  const assetDataListColumn = [
    {
      title: 'Security Code',
      dataIndex: 'securityCode',
      key: 'securityCode',
    },
    {
      title: 'Symbol Code',
      dataIndex: 'symbolCode',
      key: 'symbolCode',
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
      key: 'quantity',
      align: 'right',
      render: text => Number(text).toLocaleString('en-US'),
    },
    {
      title: 'Selling Power',
      dataIndex: 'sellingPower',
      key: 'sellingPower',
      align: 'right',
      render: text => Number(text).toLocaleString('en-US'),
    },
    {
      title: 'Holding Quantity',
      dataIndex: 'holdingQuantity',
      key: 'holdingQuantity',
      align: 'right',
      render: text => Number(text).toLocaleString('en-US'),
    },
    {
      title: 'Freeze Quantity',
      dataIndex: 'freezeQuantity',
      key: 'freezeQuantity',
      align: 'right',
      render: text => Number(text).toLocaleString('en-US'),
    },
  ];

  const assetDataList = tradingAccountDetail ? tradingAccountDetail.assetDataList : [];

  console.log(assetDataList);

  return (
    <>
      <SpaceWrapper>
        <Title level={4} style={{ marginTop: 0 }}>
          Trading Account Detail
        </Title>
        <Form onFinish={handleSearch} form={form}>
          <Space>
            <Form.Item
              name={'tradingAccountNo'}
              rules={[
                {
                  required: true,
                  message: 'Require trading account no.',
                },
              ]}
            >
              <Input
                // placeholder="Trading Account No..."
                size={'middle'}
                allowClear
                prefix={<SearchOutlined />}
              />
            </Form.Item>
            <Form.Item>
              <Button type="primary" size={'middle'} htmlType="submit">
                Search
              </Button>
            </Form.Item>
          </Space>
        </Form>
      </SpaceWrapper>

      {/* Detail Information */}
      <Descriptions>
        <Descriptions.Item label="Trading Account No">
          <Text strong>{tradingAccountDetail?.tradingAccountNo}</Text>
        </Descriptions.Item>
        <Descriptions.Item label="Trading Account Type">
          <Text strong>{tradingAccountDetail?.tradingAccountType}</Text>
        </Descriptions.Item>
        <Descriptions.Item label="Currency">
          <Text strong>{tradingAccountDetail?.currency}</Text>
        </Descriptions.Item>
        <Descriptions.Item label="Bank Balance">
          <Text strong>
            {tradingAccountDetail
              ? Number(tradingAccountDetail.bankBalance).toLocaleString('en-US')
              : ''}
          </Text>
        </Descriptions.Item>
        <Descriptions.Item label="Buying Power">
          <Text strong>
            {tradingAccountDetail
              ? Number(tradingAccountDetail.buyingPower).toLocaleString('en-US')
              : ''}
          </Text>
        </Descriptions.Item>
        <Descriptions.Item label="Reserved Fee Amount">
          <Text strong>
            {tradingAccountDetail
              ? Number(tradingAccountDetail.reservedFeeAmount).toLocaleString('en-US')
              : ''}
          </Text>
        </Descriptions.Item>
        <Descriptions.Item label="Placed Order Amount">
          <Text strong>
            {tradingAccountDetail
              ? Number(tradingAccountDetail.placedOrderAmount).toLocaleString('en-US')
              : ''}
          </Text>
        </Descriptions.Item>
        <Descriptions.Item label="Debit Amount">
          <Text strong>
            {tradingAccountDetail
              ? Number(tradingAccountDetail.debitAmount).toLocaleString('en-US')
              : ''}
          </Text>
        </Descriptions.Item>
        {/* Add more properties as needed */}
      </Descriptions>

      {/* <Card
        title={
          <Title level={5} style={{ margin: 0 }}>
            Asset List
          </Title>
        }
        headStyle={{ backgroundColor: '#eaeaea' }}
        bodyStyle={{ paddingLeft: '.5rem', paddingRight: '.5rem' }}
      >
        <Table columns={assetDataListColumn} dataSource={assetDataList} size="small" bordered />
      </Card> */}
      <Title level={5} style={{ margin: '2rem 0 1rem 0' }}>
        Asset List
      </Title>
      {/* <Divider /> */}
      <Table
        loading={loading}
        columns={assetDataListColumn}
        dataSource={assetDataList.map(asset => ({ ...asset, key: asset.assetId }))}
        size={'large'}
        scroll={{ x: 'max-content' }}
        bordered
      />
    </>
  );
};

export default ShareHolding;
